<template>
  <span>{{ undetectedareaStataus }}</span>
</template>
<script>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

export default {
  props: {
    enabledUndetectedarea: {
      type: Boolean,
      require: true,
    },
  },
  setup(props) {
    const { t } = useI18n();
    const undetectedareaStataus = computed(() => {
      if (props.enabledUndetectedarea == true) {
        return t("devices.undetectedareaStataus.enable");
      } else {
        return t("devices.undetectedareaStataus.disable");
      }
    });
    return {
      undetectedareaStataus,
    };
  },
};
</script>
